<script setup lang="ts">
import SchoolJoinView from 'src/modules/School/views/SchoolJoinView/SchoolJoinView.vue';

// Enrollment-link target (public, non-/school path so unauthenticated users reach it
// instead of being bounced to login by the school guard). Route wrapper only —
// orchestration lives in SchoolJoinView.
</script>

<template>
  <SchoolJoinView />
</template>
